import styled from "styled-components";
import { Card as BsCard, Button as BsButton } from "react-bootstrap";

export const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;

  @media (min-width: 576px) {
    justify-content: flex-start;
  }
`;

export const Card = styled(BsCard)`
  && {
    width: 100%;
    min-height: 262px;
    border: 0;
    border-radius: 18px;
    box-shadow: 0 10px 18px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    background: #fff;
    display: flex;
    flex-direction: column;
    cursor: pointer;

    @media (min-width: 576px) {
      width: 256px;
    }
  }
`;

export const Thumb = styled.div`
  height: 120px;
  background: #f2f2f2;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const Body = styled.div`
  flex: 1;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 0.8rem;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Meta = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  color: #6b7280;
  font-size: 0.8rem;
  margin-bottom: 0.9rem;

  .fa-icon {
    color: #e08a3e;
  }
`;


export const Buttons = styled.div`
  margin-top: auto;
  display: grid;
  gap: 10px;
  grid-template-columns: ${(p) =>
    (p as any)["data-count"] === 1 ? "1fr" : "1fr 1fr"};
`;

export const EditButton = styled(BsButton)`
  && {
    border: 2px solid #e08a3e;
    background: #fff;
    color: #a65a16;
    font-weight: 800;
    font-size: 0.85rem;
    line-height: 1.1rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    border-radius: 5px;
  }
  &&:hover {
    background: #fcebdd;
    color: #a65a16;
  }
`;

export const DeleteButton = styled(BsButton)`
  && {
    border: 2px solid #fcebdd;
    background: #fcebdd;
    color: #a65a16;
    font-weight: 800;
    font-size: 0.85rem;
    line-height: 1.1rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    border-radius: 5px;
  }
  &&:hover {
    background: #fde2c8;
    color: #a65a16;
  }
`;
